export default "__VITE_ASSET__DA8LXj$W__"